import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { formatDate } from "../../../utils/commonFunctions";

type AppProps = {
  tableHeader: TableHeadersType[];
  currencySign: string | undefined;
  paymentPendingList: any[] | [];
  handleChangeAmount: (data: number, id: number) => void;
};

const AllocationBody = ({
  tableHeader,
  currencySign,
  paymentPendingList,
  handleChangeAmount,
}: AppProps) => {
  const renderItemTableRow = () => {
    const finalData = paymentPendingList?.map((singleItem: any) => {
      return (
        <>
          <tr>
            {tableHeader?.length &&
              tableHeader?.map((item: any) => {
                if (item.value == "invoice_no") {
                  return <td>{singleItem?.voucher_invoice_number ? singleItem?.voucher_invoice_number : "--/--"}</td>;
                } else if (item.value == "invoice_date") {
                  return (
                    <td>{formatDate(singleItem?.voucher_invoice_date)}</td>
                  );
                } else if (item.value == "total_amount") {
                  return (
                    <td>
                      <span className="mr-1">{currencySign}</span>
                      {<span>{singleItem?.net_amount}</span>}
                    </td>
                  );
                } else if (item.value == "remaining_amount") {
                  return (
                    <td>
                      <div className="box_with_shadow allocated-yellow">
                        <span className="mr-1">{currencySign}</span>{" "}
                        <span>
                          {singleItem?.remaining_amount
                            ? (+singleItem?.remaining_amount)?.toFixed(2)
                            : 0}
                        </span>
                      </div>
                    </td>
                  );
                } else if (item.value == "allocate_amount") {
                  return (
                    <td>
                      {
                        <input
                          type="number"
                          className="form-control"
                          value={singleItem?.singleAmount ? singleItem?.singleAmount : ""}
                          placeholder="Enter Amount"
                          name="allocated_amount"
                          onChange={(e: any) =>
                            handleChangeAmount(e.target.value, singleItem?.invoice_id)
                          }
                          onWheel={event => event.currentTarget.blur()}
                        />
                      }
                    </td>
                  );
                } else {
                  return <td className="text-center"> --/-- </td>;
                }
              })}
          </tr>
        </>
      );
    });
    return finalData;
  };

  return <>{renderItemTableRow()}</>;
};

export default AllocationBody;
